import { formatISO } from 'date-fns';

const formatDateISO = (d) => formatISO(d, { representation: 'date' });

export default formatDateISO;
